import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { HOST, ROUTE_NAME_OPTIONS } from '../utils/constants.ts';
import AuthLayout from './AuthLayout.tsx';
import './login.scss';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!token) return toast.error('Token inválido o faltante.');
    if (!password || !confirmPassword)
      return toast.error('Completa ambos campos.');
    if (password.length < 8)
      return toast.error('La contraseña debe tener al menos 8 caracteres.');
    if (password !== confirmPassword)
      return toast.error('Las contraseñas no coinciden.');

    try {
      const res = await fetch(`${HOST}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, token }),
      });

      if (!res.ok) {
        let errorMessage = 'Error al cambiar la contraseña';
        try {
          const err = await res.json();
          errorMessage = err.message || errorMessage;
        } catch {
          errorMessage =
            'El servidor no está disponible. Intenta de nuevo más tarde.';
        }
        throw new Error(errorMessage);
      }

      toast.success('Tu contraseña fue actualizada con éxito.');
      navigate(`/${ROUTE_NAME_OPTIONS.LOGIN}`);
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  };

  return (
    <AuthLayout>
      <h2>Restablecer Contraseña</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="password" className="label">
          Nueva contraseña
        </label>
        <input
          type="password"
          id="password"
          placeholder="Ingresá tu nueva contraseña"
          className="input-button"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <label htmlFor="confirmPassword" className="label">
          Repetir contraseña
        </label>
        <input
          type="password"
          id="confirmPassword"
          placeholder="Repetí tu nueva contraseña"
          className="input-button"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <div className="margin-top-15">
          <button type="submit" className="primary-button">
            Actualizar contraseña
          </button>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;
